// لوحة العشرة الأوائل - تبنى كـ HTML مستقل (CSS + SVG داخلي) عشان نفس الكود
// يستخدم فى المعاينة وفى تصدير الصورة PNG والطباعة PDF
export const BOARD_WIDTH = 1000
export const BOARD_HEIGHT = 1414 // نفس نسبة A4

const FONT_CSS_URL = 'https://fonts.googleapis.com/css2?family=Cairo:wght@600;700;800;900&display=swap'

function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]))
}

function starPath(cx, cy, R, r, n = 5) {
  let d = ''
  for (let i = 0; i < n * 2; i++) {
    const rad = i % 2 ? r : R
    const a = -Math.PI / 2 + (i * Math.PI) / n
    d += `${i ? 'L' : 'M'}${(cx + rad * Math.cos(a)).toFixed(1)} ${(cy + rad * Math.sin(a)).toFixed(1)}`
  }
  return `${d}Z`
}

function sparkle(x, y, s) {
  const k = s * 0.18
  return `M${x} ${y - s}Q${x + k} ${y - k} ${x + s} ${y}Q${x + k} ${y + k} ${x} ${y + s}`
    + `Q${x - k} ${y + k} ${x - s} ${y}Q${x - k} ${y - k} ${x} ${y - s}Z`
}

function crownSvg(id, w, h) {
  return `<svg viewBox="0 0 120 84" width="${w}" height="${h}">
    <defs><linearGradient id="${id}" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#fff0b8"/><stop offset=".5" stop-color="#ebbb4b"/><stop offset="1" stop-color="#b07d22"/>
    </linearGradient></defs>
    <path d="M12 62 L6 22 L36 42 L60 10 L84 42 L114 22 L108 62 Z" fill="url(#${id})" stroke="#9a6a1c" stroke-width="2.5" stroke-linejoin="round"/>
    <rect x="11" y="62" width="98" height="14" rx="4" fill="url(#${id})" stroke="#9a6a1c" stroke-width="2.5"/>
    <circle cx="6" cy="20" r="6" fill="url(#${id})" stroke="#9a6a1c" stroke-width="2"/>
    <circle cx="60" cy="8" r="7" fill="url(#${id})" stroke="#9a6a1c" stroke-width="2"/>
    <circle cx="114" cy="20" r="6" fill="url(#${id})" stroke="#9a6a1c" stroke-width="2"/>
    <circle cx="60" cy="47" r="7" fill="#0e7c7b" stroke="#fff3c4" stroke-width="2"/>
    <circle cx="33" cy="54" r="4.5" fill="#c0392b" stroke="#fff3c4" stroke-width="1.5"/>
    <circle cx="87" cy="54" r="4.5" fill="#c0392b" stroke="#fff3c4" stroke-width="1.5"/>
  </svg>`
}

const SHIELDS = {
  1: { id: 't10-sh1', c1: '#ffe08a', c2: '#d28f1c', stroke: '#9a6212' },
  2: { id: 't10-sh2', c1: '#e9edf2', c2: '#7d8896', stroke: '#5b6470' },
  3: { id: 't10-sh3', c1: '#f3b48a', c2: '#a24e22', stroke: '#7a3816' },
}

function shieldSvg(rank, w = 50) {
  const s = SHIELDS[rank]
  return `<svg class="t10-shield" viewBox="0 0 56 64" width="${w}" height="${Math.round((w * 64) / 56)}">
    <defs><linearGradient id="${s.id}" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="${s.c1}"/><stop offset="1" stop-color="${s.c2}"/>
    </linearGradient></defs>
    <path d="M28 2 L52 10 V30 C52 46 41 56 28 62 C15 56 4 46 4 30 V10 Z" fill="url(#${s.id})" stroke="${s.stroke}" stroke-width="2.5" stroke-linejoin="round"/>
    <path d="M28 8 L46 14 V30 C46 42 38 50 28 55 C18 50 10 42 10 30 V14 Z" fill="none" stroke="#fff" stroke-opacity=".55" stroke-width="1.5"/>
    <text x="28" y="41" text-anchor="middle" font-size="27" font-weight="800" fill="#fff" font-family="Cairo, Segoe UI, Tahoma, sans-serif">${rank}</text>
  </svg>`
}

const ICONS = {
  chart: `<svg viewBox="0 0 48 48">
    <rect x="6" y="30" width="8" height="13" rx="1.5" fill="#12908e"/>
    <rect x="18" y="23" width="8" height="20" rx="1.5" fill="#0e7c7b"/>
    <rect x="30" y="16" width="8" height="27" rx="1.5" fill="#0b5a5f"/>
    <path d="M5 22 L17 13 L25 17 L40 5" stroke="#1f9e6e" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M33 5 H40 V12" stroke="#1f9e6e" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  bulb: `<svg viewBox="0 0 48 48">
    <path d="M24 9 C16.5 9 11.5 14.5 11.5 21.5 C11.5 26 14 29 17 32 C18.2 33.2 18.5 35 18.5 36.5 H29.5 C29.5 35 29.8 33.2 31 32 C34 29 36.5 26 36.5 21.5 C36.5 14.5 31.5 9 24 9 Z" fill="#fff7dc" stroke="#0e7c7b" stroke-width="3" stroke-linejoin="round"/>
    <path d="M20 29 L24 21 L28 29" stroke="#e0a93a" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 40.5 H29 M20.5 44.5 H27.5" stroke="#0e7c7b" stroke-width="3" stroke-linecap="round"/>
    <path d="M24 1.5 V4.5 M8.5 6.5 L10.5 8.5 M39.5 6.5 L37.5 8.5 M3 21 H6 M42 21 H45" stroke="#e0a93a" stroke-width="2.5" stroke-linecap="round"/>
  </svg>`,
  people: `<svg viewBox="0 0 48 48">
    <circle cx="10" cy="17" r="5" fill="#12908e"/>
    <path d="M1 39 C1 31 5 26.5 10 26.5 C14 26.5 17 29 17 33 V39 Z" fill="#12908e"/>
    <circle cx="38" cy="17" r="5" fill="#12908e"/>
    <path d="M47 39 C47 31 43 26.5 38 26.5 C34 26.5 31 29 31 33 V39 Z" fill="#12908e"/>
    <circle cx="24" cy="13" r="6.5" fill="#0b5a5f"/>
    <path d="M12 41 C12 30 17.5 24.5 24 24.5 C30.5 24.5 36 30 36 41 Z" fill="#0b5a5f"/>
  </svg>`,
  star: `<svg viewBox="0 0 48 48">
    <path d="${starPath(24, 25.5, 21, 9.5)}" fill="#1f9e6e" stroke="#157552" stroke-width="2" stroke-linejoin="round"/>
    <path d="${starPath(24, 25.5, 9, 4)}" fill="#a7e3c7"/>
  </svg>`,
}

const FEATURES = [
  { text: 'المواظبة الرقمية', icon: 'chart' },
  { text: 'دعم التعلم الذاتي', icon: 'bulb' },
  { text: 'المشاركة الفاعلة', icon: 'people' },
  { text: 'بناء مستقبل أفضل', icon: 'star' },
]

const LAPTOP_SVG = `<svg viewBox="0 0 280 190" width="280" height="190">
  <rect x="38" y="8" width="204" height="134" rx="11" fill="#1d2a33"/>
  <rect x="46" y="16" width="188" height="118" rx="4" fill="#f4f8fa"/>
  <rect x="46" y="16" width="38" height="118" fill="#e2ecef"/>
  <rect x="53" y="28" width="24" height="5" rx="2.5" fill="#b9cbd1"/>
  <rect x="53" y="42" width="20" height="4" rx="2" fill="#cad8dd"/>
  <rect x="53" y="54" width="22" height="4" rx="2" fill="#cad8dd"/>
  <rect x="53" y="66" width="18" height="4" rx="2" fill="#cad8dd"/>
  <rect x="53" y="78" width="21" height="4" rx="2" fill="#cad8dd"/>
  <rect x="96" y="28" width="70" height="8" rx="4" fill="#0e7c7b"/>
  <rect x="96" y="42" width="124" height="5" rx="2.5" fill="#d3e0e4"/>
  <rect x="96" y="62" width="28" height="34" rx="5" fill="#2bb3a3"/>
  <rect x="128" y="62" width="28" height="34" rx="5" fill="#7b6fd6"/>
  <rect x="160" y="62" width="28" height="34" rx="5" fill="#f28c38"/>
  <rect x="192" y="62" width="28" height="34" rx="5" fill="#2f8fe0"/>
  <rect x="96" y="104" width="124" height="5" rx="2.5" fill="#d3e0e4"/>
  <rect x="96" y="114" width="90" height="5" rx="2.5" fill="#d3e0e4"/>
  <path d="M8 146 H272 L258 168 C256 172 252 174 247 174 H33 C28 174 24 172 22 168 Z" fill="#c4ced5"/>
  <rect x="12" y="140" width="256" height="9" rx="3" fill="#e3e9ed"/>
  <rect x="118" y="140" width="44" height="5" rx="2" fill="#b3bec6"/>
</svg>`

function trophySvg() {
  return `<svg viewBox="0 0 290 380" width="290" height="380">
    <defs>
      <linearGradient id="t10-tg" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#a8721c"/><stop offset=".3" stop-color="#ffe8a3"/><stop offset=".55" stop-color="#f1c458"/><stop offset="1" stop-color="#9c6516"/>
      </linearGradient>
      <linearGradient id="t10-tg2" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#f7d97f"/><stop offset="1" stop-color="#a8721c"/>
      </linearGradient>
      <radialGradient id="t10-glow" cx=".5" cy=".5" r=".5">
        <stop offset="0" stop-color="#fff6d8" stop-opacity=".95"/><stop offset="1" stop-color="#fff6d8" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="145" cy="125" r="140" fill="url(#t10-glow)"/>
    <path d="M78 58 C22 52 18 140 92 158" fill="none" stroke="url(#t10-tg2)" stroke-width="15" stroke-linecap="round"/>
    <path d="M212 58 C268 52 272 140 198 158" fill="none" stroke="url(#t10-tg2)" stroke-width="15" stroke-linecap="round"/>
    <path d="M66 40 H224 C224 128 198 178 145 192 C92 178 66 128 66 40 Z" fill="url(#t10-tg)" stroke="#94601a" stroke-width="2"/>
    <ellipse cx="145" cy="40" rx="79" ry="13" fill="#ffeeb8" stroke="#94601a" stroke-width="2"/>
    <ellipse cx="145" cy="42" rx="66" ry="8" fill="#d9a441" opacity=".6"/>
    <path d="M86 62 C88 110 100 145 122 168" stroke="#fff" stroke-opacity=".55" stroke-width="7" fill="none" stroke-linecap="round"/>
    <path d="${starPath(145, 108, 36, 16)}" fill="#fff4c7" stroke="#c4912f" stroke-width="2.5" stroke-linejoin="round"/>
    <path d="M132 190 H158 L153 226 H137 Z" fill="url(#t10-tg)" stroke="#94601a" stroke-width="1.5"/>
    <path d="M108 226 H182 C182 240 168 247 145 247 C122 247 108 240 108 226 Z" fill="url(#t10-tg)" stroke="#94601a" stroke-width="1.5"/>
    <rect x="92" y="246" width="106" height="42" rx="6" fill="#4a3313"/>
    <rect x="104" y="256" width="82" height="22" rx="3" fill="url(#t10-tg)"/>
    <rect x="44" y="288" width="202" height="34" rx="7" fill="#0e7c7b"/>
    <rect x="52" y="294" width="186" height="22" rx="3" fill="#f8f2e2"/>
    <path d="M52 300.5 H238 M52 306 H238 M52 311 H238" stroke="#e3d6b5" stroke-width="1"/>
    <rect x="30" y="322" width="230" height="42" rx="8" fill="#0a5459"/>
    <rect x="38" y="329" width="214" height="28" rx="3" fill="#fbf6ea"/>
    <path d="M38 336 H252 M38 342.5 H252 M38 349 H252" stroke="#e3d6b5" stroke-width="1"/>
    <rect x="198" y="322" width="18" height="42" fill="#d9a441"/>
  </svg>`
}

function laurelSvg() {
  const cx = 150
  const cy = 158
  const r = 118
  let leaves = ''
  for (let i = 0; i < 9; i++) {
    const deg = 115 + i * 17
    const a = (deg * Math.PI) / 180
    const x = cx + r * Math.cos(a)
    const y = cy + r * Math.sin(a)
    const rot = deg + 60
    leaves += `<ellipse cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" rx="18" ry="7.5" transform="rotate(${rot.toFixed(1)} ${x.toFixed(1)} ${y.toFixed(1)})" fill="url(#t10-lf)"/>`
    leaves += `<ellipse cx="${(2 * cx - x).toFixed(1)}" cy="${y.toFixed(1)}" rx="18" ry="7.5" transform="rotate(${(-rot).toFixed(1)} ${(2 * cx - x).toFixed(1)} ${y.toFixed(1)})" fill="url(#t10-lf)"/>`
  }
  const p1 = a => [(cx + r * Math.cos((a * Math.PI) / 180)).toFixed(1), (cy + r * Math.sin((a * Math.PI) / 180)).toFixed(1)]
  const [x1, y1] = p1(108)
  const [x2, y2] = p1(258)
  return `<svg viewBox="0 0 300 300" width="300" height="300">
    <defs><linearGradient id="t10-lf" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#f6d77e"/><stop offset="1" stop-color="#b8862b"/>
    </linearGradient></defs>
    <path d="M${x1} ${y1} A${r} ${r} 0 0 1 ${x2} ${y2}" stroke="#b8862b" stroke-width="3" fill="none"/>
    <path d="M${2 * cx - x1} ${y1} A${r} ${r} 0 0 0 ${2 * cx - x2} ${y2}" stroke="#b8862b" stroke-width="3" fill="none"/>
    ${leaves}
  </svg>`
}

function medalSvg() {
  return `<svg viewBox="0 0 100 140" width="96" height="134">
    <defs><linearGradient id="t10-mg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#ffe9a6"/><stop offset=".5" stop-color="#e5b04a"/><stop offset="1" stop-color="#a8721c"/>
    </linearGradient></defs>
    <path d="M30 72 L14 132 L32 122 L42 140 L54 84 Z" fill="#0e7c7b"/>
    <path d="M70 72 L86 132 L68 122 L58 140 L46 84 Z" fill="#0a5459"/>
    <path d="${starPath(50, 50, 47, 41, 18)}" fill="url(#t10-mg)" stroke="#9a6a1c" stroke-width="1.5" stroke-linejoin="round"/>
    <circle cx="50" cy="50" r="32" fill="#f9df92" stroke="#b8862b" stroke-width="3"/>
    <path d="${starPath(50, 51, 19, 8.5)}" fill="#c48a22"/>
  </svg>`
}

function bigStarSvg() {
  return `<svg viewBox="0 0 80 80" width="74" height="74">
    <defs><linearGradient id="t10-sg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#fff0b0"/><stop offset=".55" stop-color="#f0c050"/><stop offset="1" stop-color="#b8862b"/>
    </linearGradient></defs>
    <path d="${starPath(40, 42, 36, 15)}" fill="url(#t10-sg)" stroke="#a87a22" stroke-width="2" stroke-linejoin="round"/>
  </svg>`
}

function backgroundSvg() {
  const gold = [
    [292, 70, 16], [985, 300, 13], [314, 345, 10], [610, 352, 7], [52, 760, 12], [300, 1010, 14],
    [28, 1100, 9], [940, 1150, 11], [520, 1150, 8], [180, 1395, 10], [870, 1400, 12],
  ]
  const white = [[230, 40, 9], [960, 50, 10], [140, 1210, 9], [700, 1200, 10], [990, 1270, 8]]
  return `<svg class="t10-bg" viewBox="0 0 ${BOARD_WIDTH} ${BOARD_HEIGHT}" width="${BOARD_WIDTH}" height="${BOARD_HEIGHT}">
    <defs>
      <linearGradient id="t10-teal" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#18a5a2"/><stop offset="1" stop-color="#0a565b"/>
      </linearGradient>
      <linearGradient id="t10-teal-soft" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#13908e" stop-opacity=".28"/><stop offset="1" stop-color="#13908e" stop-opacity=".04"/>
      </linearGradient>
      <linearGradient id="t10-gold" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#b8862b"/><stop offset=".5" stop-color="#ffe39a"/><stop offset="1" stop-color="#c9972f"/>
      </linearGradient>
    </defs>
    <path d="M0 0 H360 C280 26 190 46 120 100 C80 130 40 150 0 158 Z" fill="url(#t10-teal)"/>
    <path d="M360 0 C280 26 190 46 120 100 C80 130 40 150 0 158" stroke="url(#t10-gold)" stroke-width="5" fill="none"/>
    <path d="M420 0 H1000 V64 C900 24 820 104 700 74 C570 42 500 6 420 0 Z" fill="url(#t10-teal-soft)"/>
    <path d="M0 300 C140 330 250 420 262 560 C272 700 170 770 180 890 C190 990 270 1050 310 1160 L0 1160 Z" fill="url(#t10-teal-soft)"/>
    <path d="M0 336 C150 372 236 456 240 590" stroke="url(#t10-gold)" stroke-width="4" fill="none" stroke-linecap="round"/>
    <path d="M1000 380 C930 420 910 520 960 600 C990 650 1000 700 1000 720 Z" fill="url(#t10-teal-soft)"/>
    <path d="M0 1214 C180 1150 360 1262 560 1226 C760 1190 880 1118 1000 1148 V${BOARD_HEIGHT} H0 Z" fill="url(#t10-teal)"/>
    <path d="M0 1196 C180 1132 360 1244 560 1208 C760 1172 880 1100 1000 1130" stroke="url(#t10-gold)" stroke-width="7" fill="none"/>
    <path d="M0 1250 C200 1196 380 1296 580 1260 C760 1230 890 1172 1000 1196" stroke="#fff" stroke-opacity=".3" stroke-width="3" fill="none"/>
    ${gold.map(([x, y, s]) => `<path d="${sparkle(x, y, s)}" fill="#e3b54e"/>`).join('')}
    ${white.map(([x, y, s]) => `<path d="${sparkle(x, y, s)}" fill="#fff" fill-opacity=".9"/>`).join('')}
  </svg>`
}

const BOARD_CSS = `
.t10-board{position:relative;width:${BOARD_WIDTH}px;height:${BOARD_HEIGHT}px;overflow:hidden;direction:rtl;text-align:right;
  font-family:'Cairo','Segoe UI',Tahoma,Arial,sans-serif;color:#17262e;line-height:1.3;-webkit-font-smoothing:antialiased;--k:1;
  background-color:#fbf7ee;background-image:radial-gradient(circle at 78% 10%,#fff 0,rgba(255,255,255,0) 42%),
  radial-gradient(circle at 15% 22%,#fff 0,rgba(255,255,255,0) 30%),linear-gradient(180deg,#fdfaf3 0%,#f5eedd 100%)}
.t10-board *{box-sizing:border-box;margin:0;padding:0}
.t10-board svg{display:block;overflow:visible}
.t10-bg{position:absolute;left:0;top:0}
.t10-abs{position:absolute}
.t10-crown{left:595px;top:18px;z-index:3}
.t10-title{left:330px;top:84px;width:640px;height:128px;border-radius:44px;z-index:2;
  background:linear-gradient(180deg,#19a3a0 0%,#0e7273 55%,#0a5459 100%);border:4px solid #e8c063;
  box-shadow:0 12px 26px rgba(10,84,89,.35),inset 0 3px 0 rgba(255,255,255,.25);
  display:flex;align-items:center;justify-content:center;color:#fff;font-size:86px;font-weight:900;line-height:1;
  text-shadow:0 4px 8px rgba(0,0,0,.25);padding-bottom:8px}
.t10-sub{left:330px;top:192px;width:640px;display:flex;justify-content:center;z-index:3}
.t10-sub-pill{min-width:470px;max-width:610px;height:78px;padding:0 44px 6px;border-radius:40px;
  background:linear-gradient(180deg,#fdeeb8 0%,#f0c865 55%,#d8a240 100%);border:3px solid #fff5d4;
  box-shadow:0 8px 16px rgba(150,104,22,.32);display:flex;align-items:center;justify-content:center;
  color:#0b4f55;font-weight:800;white-space:nowrap;overflow:hidden}
.t10-tag{left:330px;top:284px;width:640px;text-align:center;font-size:34px;font-weight:800;color:#0b4f55}
.t10-content{left:330px;top:360px;width:640px;height:790px;display:flex;flex-direction:column;justify-content:center}
.t10-head{height:54px;border-radius:18px;margin-bottom:10px;background:linear-gradient(180deg,#14918f,#0b5a5f);
  display:flex;align-items:center;color:#fff;font-size:23px;font-weight:800;box-shadow:0 6px 14px rgba(11,90,95,.25)}
.t10-head>div{text-align:center;padding-bottom:3px}
.t10-head .t10-c-name{border-left:1px solid rgba(255,255,255,.3);border-right:1px solid rgba(255,255,255,.3)}
.t10-c-rank{width:calc(70px + 30px * var(--k));flex:none}
.t10-c-name{flex:1;min-width:0}
.t10-c-pct{width:calc(130px + 40px * var(--k));flex:none}
.t10-row{position:relative;display:flex;align-items:center;border-radius:calc(18px * var(--k));
  background:linear-gradient(180deg,#fffefa,#fbf3e2);border:1.5px solid #ecdcb2;box-shadow:0 5px 12px rgba(14,90,90,.09)}
.t10-row .t10-c-rank{position:relative;height:100%;display:flex;align-items:center;justify-content:center;
  border-radius:0 calc(16px * var(--k)) calc(16px * var(--k)) 0}
.t10-r1 .t10-c-rank{background:linear-gradient(135deg,#fff3c9,#f1cd6e)}
.t10-r2 .t10-c-rank{background:linear-gradient(135deg,#f6f8fb,#cdd5df)}
.t10-r3 .t10-c-rank{background:linear-gradient(135deg,#ffe2cf,#e7a07a)}
.t10-badge{position:relative}
.t10-list .t10-shield{width:calc(50px * var(--k));height:calc(57px * var(--k))}
.t10-mini-crown{position:absolute;top:calc(-20px * var(--k));left:50%;transform:translateX(-50%)}
.t10-mini-crown svg{width:calc(38px * var(--k));height:calc(27px * var(--k))}
.t10-num{width:calc(46px * var(--k));height:calc(46px * var(--k));border-radius:50%;display:flex;align-items:center;justify-content:center;
  background:radial-gradient(circle at 35% 30%,#fffaf0,#f4dfa4);border:2.5px solid #d6ab4f;
  font-size:calc(23px * var(--k));font-weight:800;color:#6d4c10;box-shadow:0 2px 5px rgba(150,104,22,.25)}
.t10-name{padding:0 14px 3px;text-align:center;font-weight:700;color:#17262e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.t10-row .t10-c-pct{display:flex;align-items:center;justify-content:center;padding:0 12px}
.t10-pct{width:100%;height:calc(46px * var(--k));border-radius:999px;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(180deg,#17a19e 0%,#0c6366 100%);border:2px solid #0a4f53;
  box-shadow:inset 0 2px 0 rgba(255,255,255,.25),0 3px 6px rgba(10,79,83,.25);
  color:#fff;font-size:calc(28px * var(--k));font-weight:800;direction:ltr;padding-bottom:3px}
.t10-podium{display:flex;align-items:flex-end;justify-content:center;gap:18px}
.t10-pcol{display:flex;flex-direction:column;align-items:center}
.t10-pbadge{position:relative;margin-bottom:8px}
.t10-pcrown{position:absolute;top:-36px;left:50%;transform:translateX(-50%)}
.t10-pname{width:100%;height:86px;display:flex;align-items:center;justify-content:center;text-align:center;
  font-weight:800;color:#17262e;line-height:1.35;overflow:hidden;padding:0 4px 4px}
.t10-pct.t10-ppct{width:170px;height:56px;font-size:31px;margin-top:6px}
.t10-pblock{width:100%;margin-top:16px;border-radius:24px 24px 0 0;display:flex;flex-direction:column;align-items:center;
  padding-top:18px;box-shadow:0 10px 22px rgba(10,84,89,.18),inset 0 4px 0 rgba(255,255,255,.45)}
.t10-p1 .t10-pblock{background:linear-gradient(180deg,#fbe39a 0%,#e9b949 45%,#c08a2a 100%)}
.t10-p2 .t10-pblock{background:linear-gradient(180deg,#f4f6f9 0%,#c5ced9 50%,#8c97a5 100%)}
.t10-p3 .t10-pblock{background:linear-gradient(180deg,#f8c8a6 0%,#d98a5c 50%,#a3532a 100%)}
.t10-pblock-n{font-size:96px;font-weight:900;line-height:1;color:#fff;text-shadow:0 4px 10px rgba(0,0,0,.25)}
.t10-pblock-t{font-size:22px;font-weight:800;color:#fff;text-shadow:0 2px 4px rgba(0,0,0,.25);margin-top:8px}
.t10-pbase{height:20px;border-radius:10px;background:linear-gradient(180deg,#14918f,#0a5459);box-shadow:0 6px 14px rgba(10,84,89,.3)}
.t10-hero{width:600px;margin:0 auto;border-radius:44px;padding:20px 30px 36px;text-align:center;
  background:radial-gradient(circle at 50% 26%,#fff 0,#fffbf1 40%,#f7ecd2 100%);border:3px solid #e8c063;
  box-shadow:0 16px 36px rgba(10,84,89,.18)}
.t10-hero-emblem{position:relative;width:300px;height:300px;margin:0 auto}
.t10-hero-emblem>svg{position:absolute;left:0;top:0}
.t10-hero-crown{position:absolute;top:36px;left:50%;transform:translateX(-50%)}
.t10-hero-shield{position:absolute;top:90px;left:50%;transform:translateX(-50%)}
.t10-hero-name{font-weight:900;color:#0b4f55;line-height:1.35;margin-top:4px;white-space:nowrap}
.t10-hero-label{font-size:24px;font-weight:800;color:#557075;margin-top:10px}
.t10-pct.t10-hero-pct{width:280px;height:96px;margin:6px auto 0;font-size:62px;border-width:3px}
.t10-laptop{left:25px;top:92px}
.t10-brand{left:25px;top:288px;width:280px;text-align:center;font-size:28px;font-weight:900;color:#0b5a5f}
.t10-date{left:25px;top:334px;width:280px;text-align:center;font-size:17px;font-weight:600;color:#557075}
.t10-features{left:28px;top:404px;width:274px}
.t10-feat{height:72px;margin-bottom:14px;border-radius:20px;background:rgba(255,255,255,.94);border:1px solid #e6ede8;
  box-shadow:0 6px 16px rgba(13,90,90,.10);display:flex;align-items:center;padding:0 16px}
.t10-feat-t{flex:1;min-width:0;font-size:21px;font-weight:800;color:#0b4f55;padding-bottom:3px;white-space:nowrap}
.t10-feat svg{width:42px;height:42px;flex:none;margin-right:10px}
.t10-trophy{left:20px;top:768px}
.t10-banner{left:40px;top:1170px;width:920px;height:214px;border-radius:44px;text-align:center;padding-top:14px;
  background:linear-gradient(180deg,rgba(255,253,246,.98),rgba(251,243,224,.98));border:2.5px solid #ebcf86;
  box-shadow:0 12px 28px rgba(8,60,64,.25)}
.t10-cheer{font-size:62px;font-weight:900;color:#c48a22;line-height:1.25;text-shadow:0 2px 0 #fff,0 5px 10px rgba(160,110,20,.25)}
.t10-line{font-size:27px;font-weight:700;color:#123c40;line-height:1.5}
.t10-medal{position:absolute;left:110px;top:30px}
.t10-bstar{position:absolute;right:120px;top:52px}
`

// حجم خط يخلى النص يدخل فى العرض المتاح (متوسط عرض الحرف العربى بخط Cairo ≈ نصف حجم الخط)
function fitFont(text, width, max, min) {
  return Math.max(min, Math.min(max, Math.floor(width / (Math.max(text.length, 1) * 0.5))))
}

function cleanName(student) {
  return String(student.name || '').replace(/\s+/g, ' ').trim()
}

const TITLES = ['الأوائل', 'الطالب الأول', 'الأول والثاني', 'الثلاثة الأوائل', 'الأربعة الأوائل', 'الخمسة الأوائل',
  'الستة الأوائل', 'السبعة الأوائل', 'الثمانية الأوائل', 'التسعة الأوائل', 'العشرة الأوائل']

const PLACES = { 1: 'المركز الأول', 2: 'المركز الثاني', 3: 'المركز الثالث' }

function cheerLines(n) {
  if (n === 1) return ['هنيئاً لبطلنا', 'على تفاعله المتميز في منصة مدرستي', 'متمنين له دوام التوفيق والنجاح']
  if (n === 2) return ['هنيئاً لبطلينا', 'على تفاعلهما المتميز في منصة مدرستي', 'متمنين لهما دوام التوفيق والنجاح']
  return ['هنيئاً لأبطالنا', 'على تفاعلهم المتميز في منصة مدرستي', 'متمنين لهم دوام التوفيق والنجاح']
}

// 4 - 10 طلاب: جدول، الصفوف تكبر كل ما العدد يقل عشان تملا المساحة
function listHtml(students) {
  const n = students.length
  const gap = n >= 9 ? 10 : 14
  const h = Math.min(120, Math.floor((790 - 64) / n) - gap)
  const k = Math.min(1.45, 1 + (h / 62 - 1) * 0.5)
  const nameWidth = 640 - (70 + 30 * k) - (130 + 40 * k) - 31
  const maxName = Math.round(27 * Math.min(Math.sqrt(h / 62), 1.35))
  const rows = students.map((student, i) => {
    const rank = i + 1
    const name = cleanName(student)
    const badge = rank <= 3
      ? `<div class="t10-badge">${rank === 1 ? `<div class="t10-mini-crown">${crownSvg('t10-cg2', 38, 27)}</div>` : ''}${shieldSvg(rank)}</div>`
      : `<div class="t10-num">${rank}</div>`
    return `<div class="t10-row${rank <= 3 ? ` t10-r${rank}` : ''}" style="height:${h}px;margin-bottom:${i < n - 1 ? gap : 0}px">
      <div class="t10-c-rank">${badge}</div>
      <div class="t10-c-name t10-name" style="font-size:${fitFont(name, nameWidth, maxName, 15)}px">${esc(name)}</div>
      <div class="t10-c-pct"><div class="t10-pct">${esc(student.percentage)}%</div></div>
    </div>`
  })
  return `<div class="t10-list" style="--k:${k.toFixed(3)}">
    <div class="t10-head">
      <div class="t10-c-rank">الترتيب</div>
      <div class="t10-c-name">اسم الطالب</div>
      <div class="t10-c-pct">نسبة الإنجاز</div>
    </div>
    ${rows.join('')}
  </div>`
}

// 2 - 3 طلاب: منصة تتويج (الأول فى النص)
function podiumHtml(students) {
  const n = students.length
  const colW = n === 3 ? 200 : 250
  const heights = { 1: 340, 2: 270, 3: 215 }
  const order = n === 3 ? [2, 1, 3] : [1, 2]
  // حجم خط واحد لكل الأسماء: سطر واحد لو يدخل بخط مقروء، غير كده سطرين
  const nameSize = Math.min(...students.map(student => {
    const name = cleanName(student)
    const oneLine = fitFont(name, colW * 0.92, 28, 0)
    return oneLine >= 22 ? oneLine : fitFont(name, colW * 2 * 0.8, 28, 16)
  }))
  const cols = order.map(rank => {
    const student = students[rank - 1]
    const name = cleanName(student)
    return `<div class="t10-pcol t10-p${rank}" style="width:${colW}px">
      <div class="t10-pbadge">${rank === 1 ? `<div class="t10-pcrown">${crownSvg('t10-cg2', 64, 45)}</div>` : ''}${shieldSvg(rank, 84)}</div>
      <div class="t10-pname" style="font-size:${nameSize}px">${esc(name)}</div>
      <div class="t10-pct t10-ppct">${esc(student.percentage)}%</div>
      <div class="t10-pblock" style="height:${heights[rank]}px">
        <div class="t10-pblock-n">${rank}</div>
        <div class="t10-pblock-t">${PLACES[rank]}</div>
      </div>
    </div>`
  })
  return `<div class="t10-podium">${cols.join('')}</div><div class="t10-pbase"></div>`
}

// طالب واحد: بطاقة كبيرة
function heroHtml(student) {
  const name = cleanName(student)
  return `<div class="t10-hero">
    <div class="t10-hero-emblem">
      ${laurelSvg()}
      <div class="t10-hero-crown">${crownSvg('t10-cg2', 92, 64)}</div>
      <div class="t10-hero-shield">${shieldSvg(1, 136)}</div>
    </div>
    <div class="t10-hero-name" style="font-size:${fitFont(name, 540, 52, 26)}px">${esc(name)}</div>
    <div class="t10-hero-label">نسبة الإنجاز</div>
    <div class="t10-pct t10-hero-pct">${esc(student.percentage)}%</div>
  </div>`
}

export function buildBoardHtml({ students, schoolName, reportDate }) {
  const n = students.length
  const title = TITLES[n] || TITLES[0]
  const sub = String(schoolName || '').trim() || 'على مستوى المدرسة'
  const cheer = cheerLines(n)
  let content = ''
  if (n === 1) content = heroHtml(students[0])
  else if (n === 2 || n === 3) content = podiumHtml(students)
  else if (n) content = listHtml(students)
  return `<div class="t10-board" dir="rtl">
    <style>${BOARD_CSS}</style>
    ${backgroundSvg()}
    <div class="t10-abs t10-laptop">${LAPTOP_SVG}</div>
    <div class="t10-abs t10-brand">منصة مدرستي</div>
    <div class="t10-abs t10-date">تاريخ التقرير: <span dir="ltr" style="unicode-bidi:isolate">${esc(reportDate)}</span></div>
    <div class="t10-abs t10-features">
      ${FEATURES.map(f => `<div class="t10-feat"><div class="t10-feat-t">${f.text}</div>${ICONS[f.icon]}</div>`).join('')}
    </div>
    <div class="t10-abs t10-trophy">${trophySvg()}</div>
    <div class="t10-abs t10-crown">${crownSvg('t10-cg1', 110, 77)}</div>
    <div class="t10-abs t10-title" style="font-size:${Math.min(86, Math.floor(600 / (title.length * 0.47)))}px">${title}</div>
    <div class="t10-abs t10-sub"><div class="t10-sub-pill" style="font-size:${fitFont(sub, 520, 40, 22)}px">${esc(sub)}</div></div>
    <div class="t10-abs t10-tag">الأكثر تفاعلاً في منصة مدرستي</div>
    <div class="t10-abs t10-content">${content}</div>
    <div class="t10-abs t10-banner">
      <div class="t10-medal">${medalSvg()}</div>
      <div class="t10-bstar">${bigStarSvg()}</div>
      <div class="t10-cheer">${cheer[0]}</div>
      <div class="t10-line">${cheer[1]}</div>
      <div class="t10-line">${cheer[2]}</div>
    </div>
  </div>`
}

// الخط فى المعاينة داخل الصفحة
export function ensureBoardFont() {
  if (document.getElementById('t10-font')) return
  const link = document.createElement('link')
  link.id = 't10-font'
  link.rel = 'stylesheet'
  link.href = FONT_CSS_URL
  document.head.appendChild(link)
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

// الصورة (SVG foreignObject) مايقدرش يحمل خطوط خارجية، فنضمّن ملفات الخط base64
let embeddedFontPromise = null
function getEmbeddedFontCss() {
  if (!embeddedFontPromise) {
    embeddedFontPromise = fetch(FONT_CSS_URL)
      .then(r => r.text())
      .then(async css => {
        const urls = Array.from(new Set(css.match(/https:\/\/[^)'"]+/g) || []))
        const map = {}
        await Promise.all(urls.map(async u => {
          map[u] = await blobToDataUrl(await fetch(u).then(r => r.blob()))
        }))
        return css.replace(/https:\/\/[^)'"]+/g, u => map[u] || u)
      })
      .catch(() => {
        embeddedFontPromise = null
        return ''
      })
  }
  return embeddedFontPromise
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

export async function boardToBlob(html, scale = 2) {
  const fontCss = await getEmbeddedFontCss()
  const wrap = document.createElement('div')
  wrap.innerHTML = html
  if (fontCss) {
    const style = document.createElement('style')
    style.textContent = fontCss
    wrap.insertBefore(style, wrap.firstChild)
  }
  const xhtml = new XMLSerializer().serializeToString(wrap)
  const w = BOARD_WIDTH * scale
  const h = BOARD_HEIGHT * scale
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${BOARD_WIDTH} ${BOARD_HEIGHT}">`
    + `<foreignObject x="0" y="0" width="${BOARD_WIDTH}" height="${BOARD_HEIGHT}">${xhtml}</foreignObject></svg>`
  const img = await loadImage(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`)
  // مهلة بسيطة عشان الخط المضمّن يكون اترسم قبل النسخ للـ canvas
  await new Promise(r => setTimeout(r, 150))
  const canvas = document.createElement('canvas')
  canvas.width = w
  canvas.height = h
  canvas.getContext('2d').drawImage(img, 0, 0, w, h)
  return new Promise((resolve, reject) => {
    canvas.toBlob(b => (b ? resolve(b) : reject(new Error('toBlob failed'))), 'image/png')
  })
}
